import { I18n } from "i18n-js"
import React from "react"

import { DEFAULT_LOCALE } from "@/constants/locales"
import { replacePlaceholdersWithComponents } from "@/i18n/replacements"

import translations from "./translations.json"

type ReactExtendedI18n = I18n & {
  react: (key: string, interpolations: Record<string, React.ReactNode>) => React.ReactNode[]
}

const i18n = new I18n(translations) as ReactExtendedI18n
i18n.defaultLocale = DEFAULT_LOCALE
i18n.locale = DEFAULT_LOCALE
i18n.react = (key, interpolations) => replacePlaceholdersWithComponents(i18n.get(key), interpolations)

// @ts-expect-error -- assigning i18n to window for debugging
window.i18n = i18n
export default i18n
